export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6638.41e9ab8a.jpg";